// Auth
import { getApiSessionOptions } from "Auth/apiSession";

export const callQBookingApi = async (method, path, payload) =>
  method("QBookingResource", path, payload, await getApiSessionOptions());
